import RatingsInputComponent from '@wix/thunderbolt-elements/src/components/RatingsInput/viewer/RatingsInput';
import RatingsInputController from '@wix/thunderbolt-elements/src/components/RatingsInput/viewer/RatingsInput.controller';


const RatingsInput = {
  component: RatingsInputComponent,
  controller: RatingsInputController
};


export const components = {
  ['RatingsInput']: RatingsInput
};

